import { trunkShowGraphQuery } from 'config/prismicGraphQueries'
import Head from 'next/head'
import prismic from 'services/prismic'

import Divider from 'components/Divider'
import FormattedDateRange from 'components/FormattedDateRange'
import Header from 'components/Header'
import PrismicPage from 'components/PrismicPage'
import Spacer from 'components/Spacer'
import Text from 'components/Text'

import { LocationBadge, TrunkShowHeader } from './[uid].style'
import HK from './svg/hk-y.svg'
import NY from './svg/ny-y.svg'
import SH from './svg/sh-y.svg'

const locationBadges = {
  HK: HK,
  SH: SH,
  NY: NY,
}

export default function TrunkShow({ document, location, title, startDate, endDate, locationBadge }) {
  const badge = locationBadges?.[locationBadge]

  return (
    <>
      <Head>
        <title>{title} - The Armoury</title>
      </Head>
      <TrunkShowHeader>
        {badge && (
          <>
            <LocationBadge>{badge({ viewBox: '0 0 249.5 437.6' })}</LocationBadge>
            <Spacer y={2} />
          </>
        )}
        <Text>{location}</Text>
        <Spacer y={4} />
        <Header>{title}</Header>
        <Spacer y={6} />
        <Text>
          <FormattedDateRange start={startDate} end={endDate} />
        </Text>
      </TrunkShowHeader>
      <Spacer y="insetY" />
      <PrismicPage document={document} />
      <Spacer y="insetY" />
      <Divider />
    </>
  )
}

export async function getServerSideProps({ params }) {
  const document = await prismic.getByUID('trunk_show', params.uid, { graphQuery: trunkShowGraphQuery })

  return {
    props: {
      document,
      location: document.data.location,
      locationBadge: document?.data?.location_tag,
      title: document.data.title,
      startDate: document.data.start_date,
      endDate: document.data.end_date,
    },
  }
}
